export type ProductStockStatus = 'active' | 'low_stock' | 'no_stock' | 'inactive';

export function getProductStockStatus(
  stockValue: number,
  minStockValue: number,
  currentStatus?: string,
): ProductStockStatus {
  if (currentStatus === 'inactive') return 'inactive';

  const stock = Number(stockValue) || 0;
  const minStock = Math.max(0, Number(minStockValue) || 0);

  if (stock <= 0) return 'no_stock';
  if (stock < minStock) return 'low_stock';
  return 'active';
}

export function isProductStockLow(stockValue: number, minStockValue: number): boolean {
  const stock = Number(stockValue) || 0;
  const minStock = Math.max(0, Number(minStockValue) || 0);
  return stock > 0 && stock < minStock;
}
